import { setDoc, deleteDoc, doc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * Generate a caregiver invite token.
 * Writes to invites/{token} and returns the shareable URL.
 *
 * The token is a random 20-char alphanumeric string — short enough to
 * share over SMS, long enough to be unguessable.
 *
 * The invite document stores the childId and caregiverEmail so the
 * InviteAcceptPage can look up context without needing auth.
 * Firestore rules should allow:
 *   - read of invites/{token} by anyone (to resolve on accept page)
 *   - write/delete only by the child's owner
 */
const randomToken = () => {
  const chars = "ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
  return Array.from({ length: 24 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

export const createInvite = async ({ childId, childName, ownerEmail, caregiverEmail }) => {
  const token = randomToken();
  await setDoc(doc(db, "invites", token), {
    token,
    childId,
    childName,
    ownerEmail,
    caregiverEmail: caregiverEmail.toLowerCase(),
    createdAt: serverTimestamp(),
  });
  return `${window.location.origin}/invite/${token}`;
};

export const resolveInvite = async (token) => {
  // invites are stored with a random doc id; the token field is the lookup key.
  // For simplicity, we store the doc with the token as its ID so one getDoc works.
  // This requires createInvite to use setDoc(doc(db,"invites",token), ...) below.
  const snap = await getDoc(doc(db, "invites", token));
  if (!snap.exists()) return null;
  return snap.data();
};

export const deleteInvite = async (token) => {
  await deleteDoc(doc(db, "invites", token));
};
